import {RenderItemProps} from 'src/components/elements/cart/descriptor/DescriptorType';
import {Text, StyleSheet} from 'react-native';
import Styles from 'src/components/Styles';
import Localized from 'src/constants/AppStrings';
import Icon, {FontAwesomeIconType} from '../../../icons/FontAwesomeIcon';
import Button from '../../../elements/Button';

export function searchFieldLabelDescriptor(data: typeof Localized): string {
  return `${data.Labels.searchproducts}...`;
}

export function productCatSelectedStyleDescriptor(): {
  [index: string]: number | string;
} {
  return {
    backgroundColor: Styles.Colors.CompanyKitchen.green,
    borderBottomColor: Styles.Colors.CompanyKitchen.green,
    borderTopColor: Styles.Colors.CompanyKitchen.green,
    borderStartColor: Styles.Colors.CompanyKitchen.green,
    borderEndColor: Styles.Colors.CompanyKitchen.green,
  };
}

export function productCatButtonStyleDescriptor(): {
  [index: string]: number | string;
} {
  return {
    marginRight: Styles.Spacing.m1 + 5,
    paddingHorizontal: Styles.Spacing.m3,
    paddingVertical: 8,
    marginBottom: 15,
    backgroundColor: '#FFF',
    borderRadius: 32,
    height: undefined,
    borderBottomColor: '#BCBCBC',
    borderEndColor: '#BCBCBC',
    borderStartColor: '#BCBCBC',
    borderTopColor: '#BCBCBC',
    borderWidth: 1,
    marginTop: 1,
    overflow: 'hidden',
  };
}

export function productCatSelectedTextStyleDescriptor(): {
  [index: string]: number | string;
} {
  return {
    color: Styles.Colors.CompanyKitchen.black,
  };
}

export function productCatTextStyleDescriptor(): {
  [index: string]: number | string;
} {
  return {
    fontWeight: '400',
    fontSize: Styles.Fonts.f7,
    textTransform: 'uppercase',
    fontFamily: Styles.FontFamily.latoRegular,
    color: Styles.Colors.CompanyKitchen.black,
  };
}

export function productCatrenderItem({
  item,
  index,
  selectedCategory,
  categoriesLength,
  onCategoryPress,
}: RenderItemProps): JSX.Element {
  const itemName = item.iconName ? (
    <Text maxFontSizeMultiplier={Styles.FontSizeMultiplier.maxfm1}>
      <Icon
        size={Styles.Fonts.f1}
        style={{marginRight: Styles.Spacing.m2}}
        name={item.iconName as FontAwesomeIconType}
      />
      {` ${item.name}`}
    </Text>
  ) : (
    item.name
  );

  return (
    <Button
      onPress={() => onCategoryPress(item)}
      overrideStyles={[
        productCatButtonStyleDescriptor(),
        selectedCategory === item.key && productCatSelectedStyleDescriptor(),
        index === 0 && styles.firstItemMargin,
        index === categoriesLength - 1 && styles.lastItemMargin,
      ]}
      accessibilityLabel={`${item.name} ${Localized.Buttons.category}`}
      accessibilityHint="Double tap to filter products by selected category"
      aria-label={`${item.name} ${Localized.Buttons.category}`}
      accessibilityRole="button"
      role="button"
      overrideTextStyles={[
        productCatTextStyleDescriptor(),
        selectedCategory === item.key &&
          productCatSelectedTextStyleDescriptor(),
      ]}
      text={itemName}
    />
  );
}
const styles = StyleSheet.create({
  lastItemMargin: {
    marginRight: Styles.Spacing.m3,
  },
  firstItemMargin: {
    marginLeft: Styles.Spacing.m3,
  },
});

export default {
  productCatSelectedStyleDescriptor,
  productCatButtonStyleDescriptor,
  searchFieldLabelDescriptor,
  productCatrenderItem,
  productCatTextStyleDescriptor,
  productCatSelectedTextStyleDescriptor,
};
